export default {
    prompt:"Underline Color?",
    condition:{field:"linkHover",value:"underline"},
    field:"--underlineColor",
    type:"style",
    colorPicker:true,
    default:"#ffffff"
}